export default __webpack_public_path__ + "static/media/Deo-Magnetic.ea51c9e1.jpg";